import React from 'react';
import './ActionMenu.css';

/**
 * Shared ActionMenu component for table rows.
 * Shows a three-dot trigger that reveals action buttons on hover.
 * 
 * @param {Object} props
 * @param {Array} props.actions - List of actions: { icon, label, onClick, variant, tooltip }
 */
export default function ActionMenu({ actions = [] }) {
    if (!actions || actions.length === 0) return null;

    return (
        <div className="action-menu-container" onClick={(e) => e.stopPropagation()}>
            <div className="action-menu-trigger">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="1" /><circle cx="12" cy="5" r="1" /><circle cx="12" cy="19" r="1" />
                </svg>
            </div>
            <div className="action-menu-dropdown">
                {actions.map((action, index) => {
                    if (action.isDivider) {
                        return <div key={index} className="action-menu-divider" />;
                    }
                    return (
                        <button
                            key={index}
                            onClick={(e) => {
                                e.stopPropagation();
                                action.onClick(e);
                            }}
                            className={`action-menu-item ${action.variant || ''}`}
                            data-tooltip={action.tooltip || action.label}
                        >
                            {action.icon}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
